const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 14 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>path ' + (props.className || '')}
    >
      <path d="M12.4119 21.1209H11.859C6.76678 21.1209 2.73304 17.0171 2.73304 11.3069V1.93852C2.71144 1.59633 2.55807 1.27511 2.30417 1.04032C2.05027 0.805518 1.71495 0.674805 1.36652 0.674805C1.01809 0.674805 0.682767 0.805518 0.428869 1.04032C0.17497 1.27511 0.0215983 1.59633 0 1.93852L0 11.1774C0 18.7943 5.26597 23.6133 11.7642 23.691H12.4119C13.4651 23.691 13.9548 23.1158 13.9548 22.4059C13.9548 21.6961 13.4756 21.1209 12.4119 21.1209Z" fill="white"/>
    </svg>
  );
}
